import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    name: String,
    params: Object
  }

  connect() {
    if (typeof window.gtag !== "function" || !this.hasNameValue) return

    window.gtag("event", this.nameValue, this.paramsValue || {})
  }
}
